import {
    GET_COMPANY_BEGIN, GET_COMPANY_SUCCESS, GET_COMPANY_FAILURE, CLEAN_COMPANY
} from '../constants/ActionTypes'

const initialState = {

    // Get Company
    searchedCompany: null,
    isSearchingForCompany: false,
    hasErrorSearchedCompany: null

}

/**
 * @description Reducer function for managing company state.
 *
 * @author Maria Eduarda Franke
 * @param {Object} state - The current state.
 * @param {Object} action - The action object.
 * @returns {Object} - The new state.
 */
const ReducerCompany = (state = initialState, action) => {
    switch (action.type) {

    // Get Company
    case GET_COMPANY_BEGIN: {
        return {
            ...state,
            isSearchingForCompany: true
        }
    }
    case GET_COMPANY_SUCCESS: {
        return {
            ...state,
            searchedCompany: action.payload,
            isSearchingForCompany: false,
            hasErrorSearchedCompany: null
        }
    }
    case GET_COMPANY_FAILURE: {
        return {
            ...state,
            searchedCompany: null,
            isSearchingForCompany: false,
            hasErrorSearchedCompany: action.payload
        }
    }

    // Clean Company
    case CLEAN_COMPANY: {
        return {
            ...state,
            searchedCompany: null,
            isSearchingForCompany: false,
            hasErrorSearchedCompany: null
        }
    }

    default: return state

    }
}

export default ReducerCompany